import secureLocalStorage from "react-secure-storage";

export const setToStorage = (key, data) => {
  secureLocalStorage.setItem(key, data);
};

export const getFromStorage = (key) => {
  return secureLocalStorage.getItem(key);
};

export const removeFromStorage = (key) => {
  secureLocalStorage.removeItem(key);
};
